import { type ClusterGroup } from "../types/types";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/search/clustergroups?selectionGroup=HOUSINGS");

export async function getHousingClusterGroups(): Promise<ClusterGroup[]> {
  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });

  if (response.redirected) {
    window.location.reload();
  }

  if (!response.ok) {
    throw Error(response.statusText);
  }

  const data: ClusterGroup[] = await response.json();

  data.forEach((group) => {
    if (group.code === "housing_type") {
      group.clusterItems.forEach((item) => (item.imageUrl = HOUSING_TYPE_IMAGES[item.code]));
    }
    if (group.code === "housing_shapes") {
      group.clusterItems.forEach((item) => (item.imageUrl = HOUSING_SHAPE_IMAGES[item.code]));
    }
  });

  return data;
}

const HOUSING_TYPE_IMAGES = {
  housing_sort__Plummer: "https://cdn.schaeffler-ecommerce.com/cdn/00197793_e.png",
  "housing_sort__Take-up": "https://cdn.schaeffler-ecommerce.com/cdn/001977A1_e.png",
  housing_sort__Flanged: "https://cdn.schaeffler-ecommerce.com/cdn/001977A7_e.png",
};

const HOUSING_SHAPE_IMAGES = {
  housing_shape__Dreieck_eckig: "https://cdn.schaeffler-ecommerce.com/cdn/0019779D_e.png",
  housing_shape__Dreieck: "https://cdn.schaeffler-ecommerce.com/cdn/0019779A_e.png",
  housing_shape__Viereck: "https://cdn.schaeffler-ecommerce.com/cdn/0019779F_e.png",
  housing_shape__Oval: "https://cdn.schaeffler-ecommerce.com/cdn/001977A7_e.png",
  housing_shape__Rund: "https://cdn.schaeffler-ecommerce.com/cdn/00197799_e.png",
};
